import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogModalComponent } from '../dialog-modal/dialog-modal.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'cgw-purchase-fees',
  templateUrl: './purchase-fees.component.html',
  styleUrls: ['./purchase-fees.component.scss'],
  standalone: true,
  imports: [MaterialModule, CommonModule],
})
export class PurchaseFeesComponent {
  @Input() precioLista: number;
  public cuotas: number[] = [1, 3, 6, 12];
  constructor(public dialogRef: MatDialogRef<DialogModalComponent>) {}

  public cerrarModal(): void {
    this.dialogRef.close();
  }
}
